import * as R from 'ramda'

export const getSourceRegionsData = R.path(['sourceRegions', 'data'])

export const getSourceRegionsError = R.path(['sourceRegions', 'error'])

export const getSourceRegionsLoadingState = R.path(['sourceRegions', 'loading'])
